<template>
  <div>
    <a-card
      :style="{ marginBottom: '1em' }"
      :header="$t('common.search')"
      :editable="false"
    >
      <template
        #header-buttons
      >
        <div class="is-pulled-right is-flex buttons">
          <a-select
            :manual-doc="userDoc"
            field="routes.failureSupplies.orderBy"
            :label="$t('common.order')"
            :options="keys($store.getters['failureSupplies/orderOptions'])"
            :labels="$store.getters['failureSupplies/orderOptions']"
          />
        </div>
      </template>

      <a-input
        :style="{ marginTop: '1em' }"
        :manual-doc="userDoc"
        field="routes.failureSupplies.search"
        :label="$t('common.quick_search')"
      />
    </a-card>
    <a-table
      :columns="user.routes.failureSupplies.columns"
      :data="$store.getters['failureSupplies/displayedItems']"
    />
    <more-docs-button
      module="failureSupplies"
    />
  </div>
</template>

<script>
import ATable from '@/components/ATable'
import MoreDocsButton from '@/components/MoreDocsButton'
import { mapGetters, mapActions } from 'vuex'
import { keys } from 'lodash'

export default {
  components: {
    MoreDocsButton
  },
  data() {
    return {
      userDoc: { module: 'user' }
    }
  },
  created () {
    this.$store.dispatch('failureSupplies/fetchDocs')
  },
  methods: {
    keys
  }
}
</script>
